import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm, useError } from '../../hooks'
import { flattenArrays } from '../../hooks/form'
import { useFirebaseCRUD } from '../../hooks/useFirebaseCRUD' // ✅ Use Firebase CRUD hook

import DropdownField from '../Form/DropdownField'
import TextField from '../Form/TextField'
import Button from '../Button'
import ContextMenu from '../ContextMenu'
import Columns from '../Columns'

export const RESOURCE_TYPES = [
  'agent',
  'dataExport',
  'incident',
  'incident.acknowledge',
  'incident.dispatch',
  'organization',
  'site',
  'user',
  'system.usertype',
  'track',
  'pin'
].sort()

export default function ({ organizationId, roleId }) {
  const navigate = useNavigate()
  const setError = useError()
  const { getDocument, updateDocument } = useFirebaseCRUD() // ✅ Firebase CRUD functions

  let [getFieldProps, formData, formError] = useForm()
  const [attributesCount, setAttributesCount] = useState(1)

  async function handleSubmit(e) {
    e.preventDefault()
    formData = flattenArrays(formData)
    const { resource, action, possession, attributes } = formData

    try {
      // ✅ 1. Get the existing role document to fetch current grants
      const roleDoc = await getDocument(
        `organizations/${organizationId}/user-roles/${roleId}`
      )
      const existingGrants = roleDoc?.grants || []

      // ✅ 2. Create a new grant object (exact same fields as used in other components)
      const newGrant = {
        id: Date.now().toString(), // generate a unique ID (same style as used in deleteGrant)
        resource,
        action,
        possession,
        attributes
      }

      // ✅ 3. Append the new grant to the existing grants array
      const updatedGrants = [...existingGrants, newGrant]

      // ✅ 4. Update the Firestore document
      await updateDocument(
        `organizations/${organizationId}/user-roles/${roleId}`,
        {
          grants: updatedGrants
        }
      )

      // ✅ 5. Redirect back to the role details page
      navigate(`/user-roles/${roleId}?organizationId=${organizationId}`)
    } catch (err) {
      if (err.message === 'validation_error') {
        formError(err.props)
      } else {
        setError(err)
      }
    }
  }

  // ✅ Attributes Input Fields (same as original)
  let attributeProps = []
  for (let i = 0; i < attributesCount; i++) {
    const name = `attributes[${i}]`

    attributeProps.push(
      <TextField
        key={name}
        name={name}
        required={true}
        {...getFieldProps()}
        defaultValue='*'
      />
    )
  }

  return (
    <div className='box'>
      <form onSubmit={handleSubmit}>
        <Columns>
          <DropdownField
            name='resource'
            label='Resource'
            required={true}
            {...getFieldProps()}>
            <option />
            {RESOURCE_TYPES.map((resource) => (
              <option key={resource} value={resource}>
                {resource}
              </option>
            ))}
          </DropdownField>

          <DropdownField
            name='action'
            label='Action'
            required={true}
            {...getFieldProps()}>
            <option />
            <option value='create'>Create</option>
            <option value='read'>Read</option>
            <option value='update'>Update</option>
            <option value='delete'>Delete</option>
          </DropdownField>

          <DropdownField
            name='possession'
            label='Possession'
            required={true}
            {...getFieldProps()}>
            <option />
            <option value='any'>Any</option>
            <option value='own'>Own</option>
          </DropdownField>
        </Columns>

        <label className='label'>Attributes</label>
        <Button
          type='button'
          // className="is-secondary"
          onClick={() => setAttributesCount(attributesCount + 1)}
          icon='fa fa-plus'>
          Add attribute
        </Button>

        <div style={{ marginTop: '1em' }}>{attributeProps}</div>

        <br />

        <div className='flex justify-end'>
          <Button type='submit'>Create</Button>
        </div>
      </form>
    </div>
  )
}
